var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpWorkIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44219C24.9974 8.76468 26.0022 8.76468 26.4803 9.44219L45.4736 36.3582C46.0345 37.1532 45.466 38.2501 44.4931 38.2501H6.50648C5.53358 38.2501 4.96508 37.1531 5.52601 36.3582L24.5193 9.44219Z",
    fill: "#0F55DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 46.75H46.75",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 8.5V46.75H30.2812V8.5C30.2812 6.1625 29.325 4.25 26.4562 4.25H24.5438C21.675 4.25 20.7188 6.1625 20.7188 8.5Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 21.25V46.75H14.875V21.25C14.875 18.9125 14.025 17 11.475 17H9.775C7.225 17 6.375 18.9125 6.375 21.25Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.125 31.875V46.75H44.625V31.875C44.625 29.5375 43.775 27.625 41.225 27.625H39.525C36.975 27.625 36.125 29.5375 36.125 31.875Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon01);
export default __webpack_public_path__ + "static/media/tp-work-icon01.0e9c6d85bcfc4f3266d790c96f53930a.svg";
export { ForwardRef as ReactComponent };